import { useCallback, useState } from 'react'

interface PinchZoomConfig {
  onZoomChange: (zoom: number) => void
}

interface PinchZoomReturn {
  handlePinchZoom: (touchEvent: React.TouchEvent) => void
  resetPinchZoom: () => void
}

const calculateDistance = (touch1: React.Touch, touch2: React.Touch): number =>
  Math.sqrt((touch1.pageX - touch2.pageX) ** 2 + (touch1.pageY - touch2.pageY) ** 2)

export const usePinchZoom = ({ onZoomChange }: PinchZoomConfig): PinchZoomReturn => {
  const [lastDistance, setLastDistance] = useState<number | null>(null)

  const handlePinchZoom = useCallback(
    (touchEvent: React.TouchEvent) => {
      touchEvent.preventDefault()

      const touch1 = touchEvent.touches[0]
      const touch2 = touchEvent.touches[1]
      const distance = calculateDistance(touch1, touch2)

      if (lastDistance !== null) {
        const scaleChange = distance / lastDistance
        onZoomChange(scaleChange)
      }

      setLastDistance(distance)
    },
    [lastDistance, onZoomChange]
  )

  const resetPinchZoom = useCallback(() => {
    setLastDistance(null)
  }, [])

  return {
    handlePinchZoom,
    resetPinchZoom
  }
}